import React from 'react';
import { PropTypes } from 'prop-types';
import { GridHelper } from 'components/Grids/GridHelper';

// eslint-disable-next-line import/prefer-default-export
export const UploadedCellRenderer = ({
  data: form
}) => <div>
  { GridHelper.dateFormatter(form.uploadDate, 'MMM DD, YYYY HH:mm:ss') }
  { form.uploadBy && <span className="text-sm"> ({ form.uploadBy })</span> }
</div>;

UploadedCellRenderer.propTypes = {
  data: PropTypes.shape({}),
  context: PropTypes.shape({})
};

UploadedCellRenderer.defaultProps = {
  context: {},
  data: {}
};
